
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;

    class Temperaturerise extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://resourcewatch.org/embed/data/explore/c4e0474f-45a7-49b1-a1da-e8f041114e9d?section=Discover&zoom=3&lat=0&lng=0&pitch=0&bearing=0&basemap=dark&labels=light&layers=%255B%257B%2522dataset%2522%253A%2522c4e0474f-45a7-49b1-a1da-e8f041114e9d%2522%252C%2522opacity%2522%253A1%252C%2522layer%2522%253A%252239daa648-a5ce-454a-a9ba-0dbb68c3b490%2522%257D%255D&page=1&sort=most-viewed&sortDirection=-1'
        };
    }

    render() {
        return (
            <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default Temperaturerise;